import * as React from 'react';
import { Col, Row } from 'antd';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Button from '../../../../components/button/Button';
import FlightInfo from '../../../../components/flightInfo/FlightInfo';
import { Status } from '../../../../const/PNRItemModel';
import './PNRItemContainer.css';
import './PNRItemContainerFlightsPrevious.css';
import { Currency } from '../../../../const/CurrencyType';

const propTypes = {
  detailPNR: PropTypes.any,
  data: PropTypes.any,
  simulateCancel: PropTypes.any
};

class PNRItemContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRedirect: false,
      urlRedirect: ''
    };
  }

  renderReturnFlight() {
    const returnFlight = this.props.data.cart.items[0].returnFlight;
    if (returnFlight) {
      return (
        <Row className="margin-eight-top-8">
          <Col>
            <FlightInfo
              name="returnFlight"
              className="FlightInfo__arrival"
              isDepartureFlight={false}
              flight={returnFlight}
              isPointsPlusMoney={this.isPointsPlusMoneyByFlight(returnFlight)}
            />
          </Col>
        </Row>
      );
    }
  }

  render() {
    return (
      <div className="PNRItemContainer padding-eight-top-56 disabledDiv">
        <Row>
          <Col>
            <FlightInfo
              name="departureFlight"
              className="FlightInfo__departure"
              isDepartureFlight={true}
              flight={this.props.data.cart.items[0].departureFlight}
              onChangeCheckbox={() => {}}
              isPointsPlusMoney={this.isPointsPlusMoneyByFlight(
                this.props.data.cart.items[0].departureFlight
              )}
            />
          </Col>
        </Row>
        {this.renderReturnFlight()}
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                pnrNumber: this.props.data.pnrNumber,
                azulNumber: this.props.azulNumber
              }
            }}
          />
        ) : null}
      </div>
    );
  }

  isPointsPlusMoneyByFlight(flight) {
    const result = flight.total.filter(value => value.currency === Currency.MONEY)[0];
    return result && result.value > 0;
  }
}

PNRItemContainer.propTypes = propTypes;

export default PNRItemContainer;



// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/PNRItem/PNRItemContainerFlightsPrevious.jsx